import { useQueryParam, StringParam } from "use-query-params";

export const EMAIL_PARAM_NAME = "email";

const useEmailParam = () => useQueryParam(EMAIL_PARAM_NAME, StringParam);

export default useEmailParam;
